module.exports = __webpack_public_path__ + "static/contact-18d6904665847e8f105b726d45cbc518.svg";